import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const logSignupFormAnalyticsSchema = {
  name: "logSignupFormAnalytics" as const,
  input: z.object({
    shopifyCustomerId: z.string().nullish(),
    anonymousId: z.string(),
    formId: z.string(),
    type: createEnum(["view", "submit"]),
    treatmentId: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
